import { FC } from 'react'
import { ValueType } from 'react-select'
import Filter from 'backoffice/components/DropRequests/Filters/Filter'
import { DraftRequestReviewStatus } from '../types/types'

type StatusOption = { value: string; label: string }

interface StatusFilterProps {
  value: string | null
  onChange: (value: string | null) => void
  className?: string
}

const StatusFilter: FC<StatusFilterProps> = ({ value, onChange, className }) => {
  const options: StatusOption[] = [
    { value: DraftRequestReviewStatus.PENDING, label: 'Pending Review' },
    { value: DraftRequestReviewStatus.APPROVED, label: 'Approved' },
    { value: DraftRequestReviewStatus.REJECTED, label: 'Rejected' },
    { value: DraftRequestReviewStatus.FLAGGED, label: 'Flagged' },
  ]

  return (
    <Filter
      options={options}
      value={options.find((opt) => opt.value === value)}
      onChange={(option: ValueType<StatusOption, false>) => onChange(option ? option.value : null)}
      placeholder="Filter by status"
      className={className}
      isClearable
    />
  )
}

export default StatusFilter
